// extracted by mini-css-extract-plugin
export default {"registrationForm":"RegistrationForm_registrationForm__3yboa","error":"RegistrationForm_error__hvKUg"};